export default "__VITE_ASSET__6jJsJFqALfPLhO5QJBlJcw__ 480w, __VITE_ASSET__$6UtFC$ggZWao0xraMGF_A__ 770w";